// BankTransferCard.tsx
import { Box, IconButton, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { BankTransferVariant } from "./themes";
import { BankTransferRoot, BankIcon, BankTitle, BankDescription } from "./themes/BankTransfer.theme";
import { DetailsForm } from "../components/DetailsForm/DetailsForm";
import { useBankTransfer } from "../hooks/useBankTransfer";

interface Props {
  bankVariant: BankTransferVariant;
}

export const BankTransferCard = ({ bankVariant = "default" }: Props) => {
  const { expandable, expanded, details, setDetails, handleToggle } = useBankTransfer({ bankVariant });

  return (
    <BankTransferRoot bankVariant={bankVariant}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: bankVariant === "payments" ? "center" : "flex-start", mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <BankIcon bankvariant={bankVariant} />
          <BankTitle bankvariant={bankVariant}>Bank Transfer</BankTitle>
        </Box>

        {expandable ? (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleToggle();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            size="small"
            aria-label={expanded ? "Collapse bank transfer details" : "Expand bank transfer details"}
          >
            <ExpandMoreIcon
              fontSize="small"
              style={{
                transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
              }}
            />
          </IconButton>
        ) : null}
      </Box>

      {bankVariant === "default" ? (
        <BankDescription bankVariant={bankVariant}>Manage your bank transfer credentials and information here.</BankDescription>
      ) : null}

      {expandable ? (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box
            sx={{ mt: 2 }}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <DetailsForm values={details} onChange={setDetails} disabled={false} />
          </Box>
        </Collapse>
      ) : null}
    </BankTransferRoot>
  );
};
